import { Flex, Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/react'
import Searchbar from './Searchbar'
import JGoogleIcon from '../../JGoogleIcon/JGoogleIcon'
import useSidebarV2 from '../useSidebarV2'
import sidebarV2Store from '../../../stores/sidebar-v2.store'

export default function SearchbarWrapper() {
  const { textColor, searchBarBackgroundColor } = useSidebarV2()
  const { reveal } = sidebarV2Store()

  return (
    <Flex marginTop='12px'>
      {reveal
        ? <Searchbar />
        : <Popover 
            placement="right-start" 
            trigger="hover" 
            closeOnBlur={false}
          >
            <PopoverTrigger>
              <Flex
                alignItems='center'
                justifyContent='center'
                width='100%'
                backgroundColor={searchBarBackgroundColor}
                height='40px'
                borderRadius='6px'
              >
                <JGoogleIcon
                  name='search'
                  fontSize='24px'
                  color={textColor}
                />
              </Flex>
            </PopoverTrigger>
            <PopoverContent 
              backgroundColor='onBackground' 
              color='background' 
              borderRadius='8px' 
              width='max-content'
            >
              <PopoverBody>
                <Searchbar />
              </PopoverBody>
            </PopoverContent>
          </Popover>
      }
    </Flex>
  )
}
